import { mapState, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import { getDayJSLocale } from '@/common/utils'
import i18n from '@/i18n';
import { payWithTinaba, getTinabaPayUrl } from '@/common/TinabaPay'

const POLLING_TIMEOUT = 3000
export function checkEmpty (data) {
  return data ? data : ''
}

export default {
  computed: {
    ...mapState('linkToPay', [
      'payment',
      'paypalData'
    ]),
    userDetails () {
      const shopAddress = this.payment.shopAddress ? this.payment.shopAddress : this.payment.businessAddress
      return {
        name: this.payment.shopName,
        address: `
          ${checkEmpty(shopAddress.street)}, ${checkEmpty(shopAddress.streetNumber)} ${checkEmpty(shopAddress.postalCode)} ${checkEmpty(shopAddress.city)} 
          <br/>${this.payment.shopPhoneNumber ? checkEmpty(this.payment.shopPhoneNumber) : checkEmpty(this.payment.businessPhoneNumber)}
          <br/>${this.payment.shopEmail ? checkEmpty(this.payment.shopEmail) : checkEmpty(this.payment.businessEmail)}
        `,
      }
    },
    paymentDetail () {
      return {
        refId : this.payment.productCodeId,
        desc : this.payment.description,
        import: this.payment.amount ? i18n.n(this.payment.amount / 100, 'currency') : null,
        validity : moment(this.payment.expireDate).locale(getDayJSLocale(i18n.locale)).format(`D MMMM YYYY HH:mm${i18n.locale == 'it'? '':' Z'}`)
      }
    },
    paymentUrl () {
      return getTinabaPayUrl(this.tinanaPayPayload).viaBrowserDeeplinkUrl
    },
    tinanaPayPayload () {
      return {
        id: this.payment.id,
        paymentCode: this.payment.qrCodeValue,
        amount: this.payment.amount
      }
    }
  },
  methods: {
    ...mapActions('linkToPay', ['triggerPoll']),
    ...mapMutations('linkToPay', ['toggleLoading']),
    handleCardPay () {
      this.$router.push({ name: 'CardPay', params: { id: `${this.payment.id}` } })
    },
    handleTinabaPay () {
      payWithTinaba(this.tinanaPayPayload)
    },
    setGlobalLoading () {
      return this.toggleLoading({ isLoading: true })
    },
    unsetGlobalLoading () {
      return this.toggleLoading({ isLoading: false })
    },
    _executePoll () {
      this.triggerPoll().then(() => {
        if (!this.isPolling) return null
        this.lastPoll = setTimeout(this._executePoll, POLLING_TIMEOUT)
      })
    },
    stopPolling () {
      if (this.lastPoll) {
        clearTimeout(this.lastPoll)
      }
      
      this.lastPoll  = null
      this.isPolling = false
    },
    initPolling () {
      if (this.isPolling) return this.stopPolling
      this.isPolling = true
      this._executePoll()
      return this.stopPolling
    }
  },
  beforeDestroy () {
    this.stopPolling()
  }
}